import { Colors } from '@qred/components-library';

export const contractStatusBadgeConfig: Record<
  string,
  {
    color: Colors;
    label: string;
  }
> = {
  OPEN_IN_COLLECTION: {
    color: 'neutral.16',
    label: 'Collection',
  },
  CLOSED_CREDIT_LIMIT_CHANGE: {
    color: 'neutral.16',
    label: 'Increased',
  },
  CLOSED_PAID_NORMAL: {
    color: 'success.500',
    label: 'PaidOff',
  },
  CLOSED_PAID_EARLY: {
    color: 'neutral.16',
    label: 'EarlyRepayment',
  },
  CLOSED_SOLD: {
    color: 'neutral.16',
    label: 'Collection',
  },
  CLOSED_WRITE_OFF: {
    color: 'success.500',
    label: 'PaidOff',
  },
};

export const posthogEventNames = {
  sidebar: {
    COMPANY_ITEM: 'company_item',
    SWITCH_COMPANY: 'switch_company',
    LOG_OUT: 'clicked_log_out',
    QRED_VISA: 'qred_visa',
    SELL_YOUR_INVOICES: 'sell_your_invoices',
    BECOME_A_TESTER: 'become_a_tester',
    CHANGE_LANGUAGE: 'language_menu',
  },
  dashboard: {
    STEPPER_LOAN_OFFER_EXPIRED: 'offer_expired',
    STEPPER_LOAN_DECISION: 'decision',
    STEPPER_PAY_OUT: 'pay_out',
    STEPPER_REVIEW: 'review',
    STEPPER_OFFER: 'offer',
    STEPPER_CONFIRMATION: 'confirmation',
    APPLY_FOR_LOAN: 'apply_now',
    APPLY_FOR_LOAN_INCREASE: 'apply_loan_increase',
    DOWNLOAD_INVOICE: 'download_invoice',
    PREVIOUS_LOAN_DOWNLOAD_INVOICE: 'previous_loan_download_invoice',
    PREVIOUS_LOAN_DOWNLOAD_ALL_INVOICES: 'previous_loan_download_all_invoices',
    FINAL_INVOICE: 'final_invoice',
    PAID_INVOICE: 'paid_invoices',
    UPCOMING_INVOICES: 'upcoming_invoices',
    DOWNLOAD_CREDIT_AGREEMENT: 'download_credit_agreement',
    DOWNLOAD_PAYMENT_PLAN: 'download_payment_plan',
    DOWNLOAD_GENERAL_AGREEMENT: 'download_general_agreement',
    FACTORING: 'factoring',
    QRED_VISA: 'qred_visa',
  },
  profile: {
    SAVE_PROFILE: 'save',
    EDIT_PROFILE: 'edit',
    CANCEL_PROFILE: 'cancel',
    UPDATE_PHONE_NUMBER: 'updates_PhoneNumber',
    UPDATE_EMAIL: 'updates_Email',
  },
};
